/**
 * Smooth scroll functionality for city page buttons
 * Handles "Delivery Options" and "Testimonials" button clicks
 */
(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Find all buttons and links that might contain "Delivery Options" or "Testimonials" text
    // This includes buttons, links styled as buttons, and any clickable elements
    const allClickableElements = document.querySelectorAll('a, button');
    
    allClickableElements.forEach(element => {
      const elementText = element.textContent.trim();
      
      if (elementText === 'Delivery Options') {
        element.addEventListener('click', handleDeliveryOptionsClick);
      } else if (elementText === 'Testimonials') {
        element.addEventListener('click', handleTestimonialsClick);
      }
    });
  }

  function handleDeliveryOptionsClick(event) {
    // Prevent default navigation if it's a link
    if (event.target.tagName === 'A' || event.currentTarget.tagName === 'A') {
      event.preventDefault();
    }
    
    // Find the delivery options section
    // Target: shopify-section shopify-section--image-with-text containing a div with:
    // color-scheme color-scheme--scheme-8567efe1-5b48-4da4-8cd9-1747045b7756 color-scheme--bg-54922f2e920ba8346f6dc0fba343d673 bordered-section
    const imageWithTextSections = document.querySelectorAll('.shopify-section.shopify-section--image-with-text');
    
    for (const section of imageWithTextSections) {
      const innerDiv = section.querySelector('.color-scheme.color-scheme--scheme-8567efe1-5b48-4da4-8cd9-1747045b7756.color-scheme--bg-54922f2e920ba8346f6dc0fba343d673.bordered-section');
      if (innerDiv) {
        scrollToElement(section);
        return;
      }
    }
    
    // Fallback: try to find any image-with-text section with the color scheme
    for (const section of imageWithTextSections) {
      const innerDiv = section.querySelector('.color-scheme--scheme-8567efe1-5b48-4da4-8cd9-1747045b7756');
      if (innerDiv) {
        scrollToElement(section);
        return;
      }
    }
    
    // Last fallback: any image-with-text section
    if (imageWithTextSections.length > 0) {
      scrollToElement(imageWithTextSections[0]);
    }
  }

  function handleTestimonialsClick(event) {
    // Prevent default navigation if it's a link
    if (event.target.tagName === 'A' || event.currentTarget.tagName === 'A') {
      event.preventDefault();
    }
    
    // Find the testimonials section
    // Target: section-stack containing section-header justify-self-center text-center,
    // within a shopify-section that has a div with:
    // section-spacing color-scheme color-scheme--scheme-8567efe1-5b48-4da4-8cd9-1747045b7756 color-scheme--bg-54922f2e920ba8346f6dc0fba343d673 bordered-section
    const sectionHeaders = document.querySelectorAll('.section-stack .section-header.justify-self-center.text-center');
    
    for (const header of sectionHeaders) {
      // Find the parent shopify-section
      const parentSection = header.closest('.shopify-section');
      if (parentSection) {
        // Check if the section contains a div with the specific color scheme classes
        const colorSchemeDiv = parentSection.querySelector('.section-spacing.color-scheme.color-scheme--scheme-8567efe1-5b48-4da4-8cd9-1747045b7756.color-scheme--bg-54922f2e920ba8346f6dc0fba343d673.bordered-section');
        if (colorSchemeDiv) {
          scrollToElement(parentSection);
          return;
        }
      }
    }
    
    // Fallback: try to find testimonials section by class
    const fallbackSection = document.querySelector('.shopify-section--testimonials');
    if (fallbackSection) {
      scrollToElement(fallbackSection);
      return;
    }
    
    // Last fallback: find any section with section-stack and section-header with center alignment
    if (sectionHeaders.length > 0) {
      const targetSection = sectionHeaders[0].closest('.shopify-section');
      if (targetSection) {
        scrollToElement(targetSection);
      }
    }
  }

  function scrollToElement(element) {
    if (!element) return;
    
    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = prefersReducedMotion ? 'auto' : 'smooth';
    
    // Scroll to the element
    element.scrollIntoView({
      behavior: behavior,
      block: 'start'
    });
    
    // Dispatch a custom event for hash change simulation (if needed)
    if (element.id) {
      window.history.replaceState(null, '', '#' + element.id);
      document.documentElement.dispatchEvent(
        new CustomEvent('hashchange:simulate', {
          bubbles: true,
          detail: { hash: '#' + element.id }
        })
      );
    }
  }
})();

